import Component from "./index.vue"

export default {
  name: "styleSheet",
  title: "Style Sheet",
  icon: require("./content-icon.svg"),
  category: "training",
  Viewer: Component,
  Editor: Component
}
